<div style="background-color: #fff; padding: 0 20px 0 20px;font-family: Arial" class="pdfViewer">
    <!-- <div style="position: absolute; top: 60px;" [ngStyle]="{width: (w - 40 ) + 'px'}">
        <div>
            <div style="width:80%; height: 40px; background-position: left; display:inline-block">
                <img [src]='reportService.templateModel.logo' style="height: 100%; margin-left: 20px;">
            </div>
            <div style="width:20%; display:inline-block">
                <p style="float: right; margin-right: 20px; font-weight: bold;">{{reportService.templateModel.caption}}
                </p>
            </div>
        </div>

        <table style="margin: 0; padding: 0; font-size: 0.9rem; width: 100%;border:solid 1px black;">
            <tbody>
                <tr style="padding:0">
                    <td style="width: 15%; ">
                        <b>Project Name:</b>
                    </td>
                    <td style="width: 35%;">
                        {{reportService.templateModel.description}}
                    </td>
                    <td style="width: 15%;">
                        <b>Project No:</b>
                    </td>
                    <td style="width: 35%;">
                        {{reportService.templateModel.pno}}
                    </td>
                </tr>
                <tr style="padding:0">
                    <td>
                        <b>Site Location:</b>
                    </td>
                    <td>
                        {{reportService.templateModel.addr}}
                    </td>
                    <td>
                        <b></b>
                    </td>
                    <td>


                    </td>
                </tr>

            </tbody>
        </table> -->

        <!-- <div style="margin: 0; border:1px solid #202124;" [ngStyle]="{height: (h - 300) + 'px'}">
            <div [ngStyle]="{height: (h -300-2) + 'px', backgroundImage: 'url(' + source.thumbnails + ')'}"
                style="background-position: center; background-repeat: no-repeat; background-size: cover;">
            </div>
        </div>
        <p style="text-align: center;font-weight: bold;font-size: 14px;">Google Base Map</p> -->

    <!-- </div> -->
    <div *ngFor="let i of pageNo">
        <div style="position: relative;" [ngStyle]="{width: (w - 40) + 'px', height: h + 'px'}">
            <div class="wt5" style="position: absolute; top: 33px;" [ngStyle]="{width: (w - 40 - 2) + 'px'}">
                <div>
                    <div style="width:80%; height: 40px; background-position: left; display:inline-block">
                        <img [src]='reportService.templateModel.logo' style="height: 100%; margin-left: 20px;">
                    </div>
                    <div style="width:20%; display:inline-block">
                        <p style="float: right; margin-right: 20px; font-weight: bold;">
                            {{reportService.templateModel.caption}}</p>
                    </div>
                </div>
                <div style="border:solid 1px black;">

                    <table style="margin: 0; padding: 0; font-size: 0.9rem; width: 100%;border:solid 1px black;">
                        <tbody>
                            <tr style="padding:0">
                                <td style="width: 15%; ">
                                    <b>Project Name:</b>
                                </td>
                                <td style="width: 35%;">
                                    {{reportService.templateModel.description}}
                                </td>
                                <td style="width: 15%;">
                                    <b>Project No:</b>
                                </td>
                                <td style="width: 35%;">
                                    {{reportService.templateModel.pno}}
                                </td>
                            </tr>
                            <tr style="padding:0">
                                <td>
                                    <b>Site Location:</b>
                                </td>
                                <td>
                                    {{reportService.templateModel.addr}}
                                </td>
                                <td>
                                    <b></b>
                                </td>
                                <td>


                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <table style="width:100%; border-top:solid 1px black;">
                        <tbody>
                            <tr>
                                <td style="width:25%; border: 1px solid black; border-collapse: collapse">
                                    <b>Photograph ID: </b><br>
                                    {{i+1}}
                                </td>
                                <td rowspan="10" style="width:75%; border: 1px solid black; border-collapse: collapse">
                                    <div style="margin: 0; width:auto; overflow:hidden; text-align: center; padding:20px"
                                        [ngStyle]="{height: (h - 160 - 80-2)/2 + 'px'}">
                                        <img style="border-style: none; margin-left:auto; margin-right:auto; height: 100%; width:100%; display:block;"
                                            class="center" [src]="photos[i].FILE_URL" />
                                    </div>
                                </td>
                            </tr>
                            <!--<tr>
                        <td style="width:25%; border: 1px solid black; border-collapse: collapse;">
                            <b>Photograph Location:</b><br>
                            {{selectedPhotos[i].title}}   
                        </td>
                    </tr>-->
                            <!-- <tr>
                                <td style="border: 1px solid black; border-collapse: collapse">
                                    <b>Photograph Tag: </b><br>
                                    {{selectedPhotos[i].photoTag}}
                                </td>
                            </tr> -->
                            <tr>
                                <td style="width:25%; border: 1px solid black; border-collapse: collapse">
                                    <b>Survey Date:</b><br>
                                    {{formattedDate(photos[i].DATE_UPDATED)}}
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="5"
                                    style="width:25%; border: 1px solid black; border-collapse: collapse; vertical-align: top;">
                                    <b>Comments: </b><br>
                                    <div style="width:100%; word-wrap: normal">
                                        <p style="width:100%; word-wrap: normal;">
                                            {{photos[i].FILE_DESCRIPTION}} </p>
                                        <!-- <textarea rows="10" ></textarea> -->
                                    </div>

                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <table *ngIf='photos.length>(i+1)' style="width:100%; border-top:solid 1px black;">
                        <tbody>
                            <tr>
                                <td style="width:25%; border: 1px solid black; border-collapse: collapse">
                                    <b>Photograph ID: </b><br>
                                    {{i+2}}
                                </td>
                                <td rowspan="10" style="width:75%; border: 1px solid black; border-collapse: collapse">
                                    <div style="margin: 0; width:auto; overflow:hidden; text-align: center; padding:20px"
                                        [ngStyle]="{height: (h - 160 - 80-2)/2 + 'px'}">
                                        <img style="border-style: none; margin-left:auto; margin-right:auto; height: 100%; width:100%; display:block;"
                                            class="center" [src]="photos[i+1].FILE_URL" />
                                    </div>
                                </td>
                            </tr>
                            <!--<tr>
                        <td style="width:25%; border: 1px solid black; border-collapse: collapse;">
                            <b>Photograph Location:</b><br>
                            {{selectedPhotos[i+1].title}}  
                        </td>
                    </tr> -->
                            <!--<tr>
                        <td style="border: 1px solid black; border-collapse: collapse">
                            <b>Direction: </b><br>  
                            {{selectedPhotos[i+1].photoDirection}}        
                        </td>
                    </tr>-->
                            <!-- <tr>
                                <td style="border: 1px solid black; border-collapse: collapse">
                                    <b>Photograph Tag: </b><br>
                                    {{selectedPhotos[i+1].photoTag}}
                                </td>
                            </tr> -->
                            <tr>
                                <td style="width:25%; border: 1px solid black; border-collapse: collapse">
                                    <b>Survey Date:</b><br>
                                    {{formattedDate(photos[i+1].DATE_UPDATED)}}
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="5"
                                    style="width:25%; border: 1px solid black; border-collapse: collapse; vertical-align: top;">
                                    <b>Comments: </b><br>
                                    <div style="width:100%; word-wrap: normal">
                                        <p style="width:100%; word-wrap: normal">
                                            {{photos[i+1].FILE_DESCRIPTION}} </p>
                                        <!-- <textarea rows="10" ></textarea> -->
                                    </div>

                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <p *ngIf="i<pageNo[pageNo.length-1]" style="page-break-after: always;">
    </div>
</div>